import React from 'react'
import styled from 'styled-components/native'

import I18n from 'APP/Services/i18n'

import Typography from 'APP/Converse/Typography'

const Subtitle = styled(Typography)`
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text};
  text-align: left;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  ${({ theme }) => theme.fonts.styles.body};
`

export const SubtitleWithEmail = ({ i18nKey, email }: { i18nKey: string; email: string }) => {
  const text: string[] = I18n.t(i18nKey, { returnObjects: true })

  return (
    <Subtitle>
      {text[0]}
      <Typography variant="bodyNormalBold">{email}</Typography>
      {text[1]}
    </Subtitle>
  )
}
